module.exports = __webpack_public_path__ + "assets/img/404.5ebdbea9.png";